function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 23">
      <path stroke="currentColor" strokeWidth="5" d="M2.5 4V0m0 23V7" />
    </svg>
  );
}

export default Icon;
